module.exports = __webpack_public_path__ + "static/media/sALPACA.3f2ca97b.svg";